const colorNames = {
  black: "black",
  blue: "blue",
  gray: "gray",
  green: "green",
  orange: "orange",
  pink: "pink",
  purple: "purple",
  red: "red",
  turquoise: "turquoise",
  white: "white",
  yellow: "yellow",
};

const colors = {
  black: "#2E2E2E",
  blue: "#2698C8",
  gray: "#D0D0D0",
  green: "#7FD258",
  orange: "#E49B57",
  pink: "#E485C4",
  purple: "#9D7CE2",
  red: "#FE6A6A",
  turquoise: "#72D7D1",
  white: "#E1E1E1",
  yellow: "#F8DF20",
};

const layout = {
  mobile: 750,
  tablet: 1000,
};

const theme = {
  colors,
  colorNames,
  layout,
};

export default theme;
